export default __webpack_public_path__ + "media/src/assets/images/ViewMore-4763a6ad3d07a81fc5d4c06db0b38d65.svg";